import classNames from 'classnames'
import React from 'react'

import styles from './SideBar.module.scss'
import GridBackground from '../../molecules/gridBackround/GridBackground'

const SideBar = (props) => {
  const { position, wide, children  } = props
  const classes = classNames(
    styles.container,
    { [styles.positionLeft]: position === 'left' },
    { [styles.positionRight]: position === 'right' },
    { [styles.wide]: wide },
  )

  return (
    <div className={classes}>
      <GridBackground>
      {children}
      </GridBackground>
    </div>
  )
}

export default SideBar

